import React, { useEffect, useState } from 'react';
import './App.css';
import logo from './assets/logo.png';
import { Checkbox, FormControlLabel, TextField } from '@mui/material';

function App() {
  const [headerMessage, setHeaderMessage] = useState("Welcome!");
  const [registrationStatus, setRegistrationStatus] = useState("not-started");
  const [idValue, setIdValue] = useState('');
  const [emailValue, setEmailValue] = useState('');
  const [checked, setChecked] = useState('');
  const [disabled, setDisabled] = useState(true);
  const [validEmail, setValidEmail] = useState(true);
  const [postError, setPostError] = useState('');

  useEffect(() => {
    setDisabled(!idValue || !emailValue || !checked);
  }, [idValue, emailValue, checked])

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }
  
  const beginRegistrationProcess = () => {
    setRegistrationStatus("started");
    setHeaderMessage("Hello there!");
  }

  const handleLoginBtnClick = () => {
    window.open("https://knaufepicedge.elevate-recognition.com/", "_self");
  }

  const handleSubmitClick = async () => {
    if(!disabled) {
      if(!validateEmail(emailValue)) {
        setValidEmail(false);
        return;
      }

      await fetch("/api/user", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          username: idValue,
          email: emailValue,
        }),
      })
      .then(async (response) => {
        if(response.status === 200) {
          return response.json();
        }
        else {
          const data = await response.json().catch(() => null);
          throw new Error(data?.message || "Something went wrong!");
        }
      })
      .then((data) => {
        setPostError('');
        setRegistrationStatus("done");
        setHeaderMessage("Thanks!");
      })
      .catch((err) => {
        console.error("Error:", err);
        setPostError(err.message);
      });
    }
  }

  return (
    <div className="App">
      <div className="card">
        {registrationStatus === 'started' && 
          <button class="back-button" onClick={() => {
            setRegistrationStatus("not-started");
            setHeaderMessage("Welcome!");
          }}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="back-icon">
              <path fill-rule="evenodd" d="M15.75 19.5L8.25 12l7.5-7.5" clip-rule="evenodd" />
            </svg>
            <span>Back</span>
          </button>
        }
        <img className="company-name" src={logo}></img>
        <h2 className={headerMessage === "Welcome!" ? "header-1" : "header-2"}>{headerMessage}</h2>
        {registrationStatus === 'not-started' && (
          <div>
            <div className="section">
              <div className="message" style={{paddingTop:"25px"}}>First time logging on?</div>
              <button onClick={beginRegistrationProcess}>Get started here</button>
            </div>
            <div className="section">
              <div className="message" style={{paddingTop:"25px"}}>Already have an account?</div>
              <button onClick={handleLoginBtnClick}>Go to the login page</button>
            </div>
          </div>
        )}
        {registrationStatus === 'started' && (
          <div>
            <div className="section">
              <div className="guidance-message-2">Need to get started? We just need a couple of pieces of information first.</div>
            </div>
            <div className="section">
              <div className="text-input">
                <TextField
                  id="user-id"
                  helperText="Login ID"
                  size="small"
                  value={idValue}
                  onChange={(e) => {
                    setIdValue(e.target.value);
                  }}
                />
              </div>
              <div className="text-input">
                <TextField
                  id="user-email"
                  helperText="Email Address"
                  size="small"
                  value={emailValue}
                  error={!validEmail}
                  onChange={(e) => {
                    setValidEmail(true);
                    setEmailValue(e.target.value);
                  }}
                />
                {!validEmail && <div className="error-text">Please enter a valid email address</div>}
              </div>
              <div className='checkbox'>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked}
                      onChange={(e) => {
                        setChecked(!checked);
                      }}
                    />
                  }
                  label="By providing us an email address, you agree to receive communications from the Knauf recognition program to this email address." 
                  />
              </div>
              <button className={disabled ? 'disabled' : ''} onClick={handleSubmitClick}>Submit</button>
              {postError && <div className="error-text-post">{postError}</div>}
            </div>
          </div>
        )}
        {registrationStatus === 'done' && (
          <div>
            <div className="section">
              <div className="guidance-message">We’ve entered your information. You should receive a welcome email within five standard business days.</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
export default App;